<template>
  <div class="container d-flex flex-row-fluid flex-column justify-content-md-center p-12">
    <h3 class="error-title font-weight-200 mt-10 mt-md-0 mb-12">
      <i class="ri-alert-line ri-5x text-danger"></i>
    </h3>
    <p class="font-weight-boldest display-4">Dalam proses development.</p>
    <p class="font-size-h3">Kami sedang mengerjakannya dan kami akan memperbaikinya sesegera mungkin.</p>
  </div>
</template>

<script>
export default {
  name: 'maintenance-menu',
  data () {
    return {

    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/default-page/maintenance.vue